import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-card__labels gfu-blog__badges" }
const _hoisted_3 = { class: "gfu-blog__tile-content _flexcol _grow-1 _mw-0" }
const _hoisted_4 = { "data-qa": "blog-post-card-channel" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  "aria-hidden": "true"
}
const _hoisted_8 = {
  key: 2,
  class: "_flexinline _ai-c _gap-1",
  "data-qa": "blog-post-poll-count"
}
const _hoisted_9 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_blog_post_restricted_visibility = _resolveComponent("blog-post-restricted-visibility")
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_text = _resolveComponent("base-text")
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(['gfu-blog__tile _pos-r _flexcol _fd-r--m _bgc--white _rounded--common', $options.variantPresentation.rootClass]),
    "data-qa": `blog-post-card:${$props.blogPost.title}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      ($props.blogPost.hasPoll)
        ? (_openBlock(), _createBlock(_component_base_badge, {
            key: 0,
            theme: "success",
            "data-qa": "blog-post-poll-badge"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Blog.PollBadge), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(['gfu-blog__channel gfu-bt gfu-bt--b2 _flex _ai-c _gap-1 _fw-eb', $options.channelPresentation.className])
      }, [
        _createVNode(_component_base_icon, {
          name: $options.channelPresentation.iconName,
          class: "_lh-1",
          size: "lg"
        }, null, 8 /* PROPS */, ["name"]),
        _createElementVNode("span", _hoisted_4, _toDisplayString($options.channelLabel), 1 /* TEXT */),
        ($props.blogPost.canEdit)
          ? (_openBlock(), _createBlock(_component_blog_post_restricted_visibility, {
              key: 0,
              "is-unpublish": !$props.blogPost.isPublished
            }, null, 8 /* PROPS */, ["is-unpublish"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createElementVNode("a", _mergeProps({
        href: $props.blogPost.blogPostUrl
      }, $options.linkAttributes, {
        class: "gfu-link gfu-link--nofx gfu-link-underline _as-fs",
        "data-qa": "blog-post-title"
      }), [
        _createVNode(_component_base_title, {
          as: $options.variantPresentation.titleTag,
          level: $options.variantPresentation.titleLevel,
          class: "gfu-blog__title gfu-link-underline__content _line-clamp-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.blogPost.title), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["as", "level"])
      ], 16 /* FULL_PROPS */, _hoisted_5),
      _createVNode(_component_base_text, {
        as: "p",
        level: $options.variantPresentation.descriptionLevel,
        class: "gfu-blog__tile-description _line-clamp-4 _my-0"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.blogPost.description), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["level"]),
      ($options.variantPresentation.isMetaVisible)
        ? (_openBlock(), _createBlock(_component_base_text, {
            key: 0,
            as: "div",
            level: "caption",
            class: "_flex _ai-c _gap-3 _pt-1 _tc--light"
          }, {
            default: _withCtx(() => [
              ($options.formattedPublishDate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($options.formattedPublishDate), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($options.formattedPublishDate && $props.blogPost.hasPoll)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "•"))
                : _createCommentVNode("v-if", true),
              ($props.blogPost.hasPoll)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createVNode(_component_base_icon, {
                      name: "poll",
                      "is-fixed-width": ""
                    }),
                    _createTextVNode(" " + _toDisplayString($options.formattedPollVotesCount), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    ($props.blogPost.thumbnailImageUrl)
      ? (_openBlock(), _createElementBlock("a", _mergeProps({
          key: 0,
          href: $props.blogPost.blogPostUrl
        }, $options.linkAttributes, {
          class: "gfu-blog__thumbnail-link _as-fs _flex-none",
          "data-qa": "blog-post-image"
        }), [
          _createVNode(_component_base_image, {
            src: $props.blogPost.thumbnailImageUrl,
            alt: $props.blogPost.title,
            loading: "lazy",
            class: "_block _aspect-square _img-of-c _w-full _bgc--neutral-50 _rounded--common _bxsh--base"
          }, null, 8 /* PROPS */, ["src", "alt"])
        ], 16 /* FULL_PROPS */, _hoisted_9))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}